import React from 'react';
import { Box } from '@metarouter-private/mr-mui';
import { useTestPlaybookDrawerContext } from 'app/playbook-editor/transform-drawer/TestPlaybookDrawerContextProvider';
import DRAWER_MODES from 'app/playbook-editor/transform-drawer/TestPlaybookDrawerContextProvider/DRAWER_MODES';
import ModeSwitch from 'app/playbook-editor/transform-drawer/components/ModeSwitch';
import BasicTabsSection from './BasicTabsSection';
import AdvancedTabsSection from './AdvancedTabsSection';

export default function DrawerTabsSection() {
  const { mode } = useTestPlaybookDrawerContext();

  return (
    <Box position="relative">
      {/* Mode toggle shares the tab bar row (right-aligned) to save vertical space. */}
      <Box position="absolute" top={8} right={0} zIndex={1}>
        <ModeSwitch />
      </Box>
      {mode === DRAWER_MODES.ADVANCED ? <AdvancedTabsSection /> : <BasicTabsSection />}
    </Box>
  );
}
